"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemChooserPopoverList = void 0;
const core_1 = require("@material-ui/core");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const PickerItem_1 = __importDefault(require("@opsbase/web-ui/PickerItem"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    list: {
        position: 'relative',
        minWidth: 200,
        overflow: 'scroll',
        flex: 1,
        paddingBottom: 0,
        border: '1px solid ${Palette.CardKeyline.main}',
    },
    listGroup: {
        backgroundColor: 'inherit',
    },
    ul: {
        backgroundColor: 'inherit',
        padding: 0,
    },
    listSubHeaderText: {
        borderBottom: `1px solid ${lib_palette_1.default.WhiteSmoke.main}`,
        background: lib_palette_1.default.WhiteSmoke.main,
        color: lib_palette_1.default.GreyBlue.main,
        fontSize: 12,
        fontWeight: 700,
        top: -20,
    },
    listItem: {
        padding: '6px 16px',
        cursor: 'pointer',
        borderBottom: `1px solid ${lib_palette_1.default.WhiteSmoke.main}`,
        background: lib_palette_1.default.White.main,
        transition: 'background 0.3s',
        '&:hover': {
            background: lib_palette_1.default.LightBlue.main,
        },
    },
    allListItem: {
        padding: '6px 16px',
        borderBottom: `1px solid ${lib_palette_1.default.InputBorderGrey.main}`,
        background: lib_palette_1.default.White.main,
        transition: 'background 0.3s',
        '&:hover': {
            background: lib_palette_1.default.LightBlue.main,
        },
    },
});
function ItemChooserPopoverList(props) {
    var _a, _b;
    const { items, selectedItems, onLoadMore, onClickItem, showType = false, allSelectable = false, allSelected = false, allSelectedLabel, onSelectAll, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const groups = (0, react_1.useMemo)(() => items === null || items === void 0 ? void 0 : items.reduce((p, c) => {
        p[c.type] = p[c.type] || [];
        p[c.type].push(c);
        return p;
    }, {}), [items]);
    const handleScroll = (0, react_1.useCallback)(e => {
        if (!onLoadMore)
            return;
        const sHeight = e.target.scrollHeight;
        const sTop = e.target.scrollTop;
        const cHeight = e.target.clientHeight;
        if (sTop + cHeight >= sHeight || sTop + cHeight >= sHeight - 1) {
            onLoadMore === null || onLoadMore === void 0 ? void 0 : onLoadMore();
        }
    }, [onLoadMore]);
    const handleClick = (0, useCallforward_1.default)(item => () => {
        onClickItem === null || onClickItem === void 0 ? void 0 : onClickItem(item);
    }, [onClickItem]);
    const handleSelectAll = (0, react_1.useCallback)(() => {
        onSelectAll === null || onSelectAll === void 0 ? void 0 : onSelectAll(!allSelected);
    }, [allSelected, onSelectAll]);
    return (react_1.default.createElement(core_1.List, { onScroll: handleScroll, className: myCss.list },
        allSelectable && onSelectAll && (react_1.default.createElement(PickerItem_1.default, { type: props.type || ((_a = items === null || items === void 0 ? void 0 : items[0]) === null || _a === void 0 ? void 0 : _a.type) || ((_b = items === null || items === void 0 ? void 0 : items[0]) === null || _b === void 0 ? void 0 : _b.__typename) || undefined, title: allSelectedLabel, selected: allSelected, onClick: handleSelectAll, className: myCss.allListItem })),
        (Object.keys(groups || {}) || []).map(group => (react_1.default.createElement("li", { key: `group-${group}`, className: myCss.listGroup },
            react_1.default.createElement("ul", { className: myCss.ul },
                showType && (react_1.default.createElement(core_1.ListSubheader, { className: myCss.listSubHeaderText }, group.toUpperCase())),
                groups[group].map(item => {
                    const selected = !!selectedItems.find(s => s.id ? s.id === item.id : s.title === item.title);
                    return (react_1.default.createElement(PickerItem_1.default, { key: item.id, type: item.type || item.__typename || undefined, title: item.title, avatarUrl: item.avatarUrl, selected: selected, onClick: handleClick(item), className: myCss.listItem }));
                })))))));
}
exports.ItemChooserPopoverList = ItemChooserPopoverList;
exports.default = ItemChooserPopoverList;
